<template>
    <div>
      <billing-status-list></billing-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  